/**
 * GA4 event tracking utilities (G-Y57BJQX5P0).
 * Events are sent via:
 *   1. window.gtag with explicit send_to targeting
 *   2. window.dataLayer.push for GTM compatibility
 */

const GA4_ID = 'G-Y57BJQX5P0';

const fireEvent = (eventName, params) => {
  // gtag.js path
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, {
      ...params,
      send_to: GA4_ID
    });
  }

  // GTM dataLayer path
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params
  });

  if (process.env.NODE_ENV === 'development') {
    console.log('GA EVENT FIRED:', eventName, params);
  }
};

/** Form submission */
export const trackGenerateLead = (formName, projectType) => {
  fireEvent('generate_lead', {
    form_name: formName,
    project_type: projectType
  });
};

/** CTA click */
export const trackCTAClick = (ctaLocation) => {
  fireEvent('cta_click', {
    cta_location: ctaLocation
  });
};

/** Phone click */
export const trackPhoneClick = (phoneNumber) => {
  fireEvent('phone_click', {
    phone_number: phoneNumber
  });
};

/** Outbound link click */
export const trackOutboundClick = (url) => {
  fireEvent('outbound_click', {
    outbound_url: url,
    transport_type: 'beacon'
  });
};

/** SPA page view */
export const trackPageView = (path, title) => {
  fireEvent('page_view', {
    page_path: path,
    page_title: title
  });
};
